import { SET_ANALYTICS_KEY } from './analyticsActionTypes';

export function setAnalyticsKey(key) {
  return {
    type: SET_ANALYTICS_KEY,
    payload: key
  };
}
